import { React } from "react";

import Footer from "../Footer";

// IMAGES FOR PAGE
import perfSect2ImgSm from "../../assets/performances/SwanLake2026/SwanLake2026Poster-300.png";
import perfSect2ImgMd from "../../assets/performances/SwanLake2026/SwanLake2026Poster-768.png";
import perfSect2ImgLg from "../../assets/performances/SwanLake2026/SwanLake2026Poster-2000.png";
import perfSect2ImgXL from "../../assets/performances/SwanLake2026/SwanLake2026Poster-2000.png";

// Gallery Images
// import gallery1 from "../../assets/performances/SwanLake2025/gallery/1.png";
// import gallery2 from "../../assets/performances/SwanLake2025/gallery/2.png";
// import gallery3 from "../../assets/performances/SwanLake2025/gallery/3.png";
// import gallery4 from "../../assets/performances/SwanLake2025/gallery/4.png";
// import gallery5 from "../../assets/performances/SwanLake2025/gallery/5.png";
// import gallery6 from "../../assets/performances/SwanLake2025/gallery/6.png";

import handbook from "../../assets/performances/SwanLake2026/SwanLakeHandbook2025-2026.pdf";
import castList from "../../assets/performances/SwanLake2026/ SwanLake2025-2026CastList.pdf";
import rehearsalAttire from "../../assets/performances/SwanLake2026/SwanLake25-26RehearsalAttire.pdf";
import rehearsalSchedule from "../../assets/performances/SwanLake2026/SwanLake2026RehearsalSchedule.pdf";
import costumeReqs from "../../assets/performances/SwanLake2026/SwanLake2026CostumeReqs.png";
import program from "../../assets/performances/SwanLake2026/SwanLake2026Program.pdf";

import PerformanceTemplate from "./templates/PerformanceTemplate";

import "./SwanLake2026.css";

function SwanLake2026() {
  const status = "PAST";
  const showName = "Swan Lake";
  const showDate = "January 17, 2026";
  const auditionDate = "September 28, 2025";
  const headerDescription = `Immerse yourself in the enchanting love story of Swan Lake. Witness Prince Siegfried's fateful encounter with the Swan Queen, Odette, as he pledges his undying love and loyalty to her. However, a cruel curse by the evil sorcerer Baron von Rothbart only allows Odette to take human form at night. Only true love and unwavering fidelity can break this powerful spell.`;

  const perfSect2ButtonLink = program;
  const perfSect2Images = {
    sm: perfSect2ImgSm,
    md: perfSect2ImgMd,
    lg: perfSect2ImgLg,
    xl: perfSect2ImgXL,
  };

  const importantLinks = [
    // { buttonLabel: "Cast list", buttonLink: castList },
    // { buttonLabel: "Rehearsal Attire", buttonLink: rehearsalAttire },
    // { buttonLabel: "rehearsal schedule", buttonLink: rehearsalSchedule },
    { buttonLabel: "Costume Requirements", buttonLink: costumeReqs },
    // { buttonLabel: "communications", buttonLink: "" }, //todo
    // { buttonLabel: "volunteers", buttonLink: "" }, //todo
  ];

  const eventCalendar = [
    {
      eventName: "Auditions",
      date: "09/28/25",
      title: "Swan Lake Auditions",
      subtitle: "September 28, 2025",
      caption: "Auditions are held at Nylia Ballet Academy",
      buttonLink: "https://form.jotform.com/252658795021160",
      buttonLabel: "Register for Auditions",
    },
    {
      eventName: "Rehearsals Begin",
      date: "09/29/25",
      caption: "All rehearsals are held at Nylia Ballet Academy",
    },
    {
      eventName: "Costume Measurements",
      date: "09/29/25",
      caption:
        "Costume measurements will be taken during the dancer's rehearsal from September 29 - October 4.",
    },
    {
      eventName: "Performance Fee Due",
      date: "10/11/25",
      title: "Performance Fee Due",
      caption: "Take a look at our handbook for detailed information!",
    },
    {
      eventName: "Rehearsal Attire Orders Due",
      date: "10/18/25",
      caption:
        "Role-specific rehearsal attire orders are due. This includes rehearsal tutus, skirts, character shoes, and more. ",
    },
    {
      eventName: "Costume Fees Due",
      date: "10/18/25",
      title: "Costume Fees Due",
      caption: "Take a look at our handbook for detailed information!",
    },
    {
      eventName: "Rehearsal Attire Required",
      date: "10/20/25",
      title: "Role-Specific Rehearsal Attire Required",
      caption:
        "All dancers must be wearing their designated rehearsal attire to all rehearsals. The rehearsal attire depends on their role in the production.",
    },
    {
      eventName: "Cast Photoshoot",
      date: "11/16/25",
      title: "Swan Lake Cast Photoshoot",
      caption:
        "Picture packages can be purchased at the front desk. Make the beautiful memories last a lifetime!",
    },
    {
      eventName: "Full Run-Throughs (ALL CAST)",
      date: "01/12/26",
      title: "Full Run-Throughs (ALL CAST)",
      subtitle: "January 12 - 16",
      caption:
        "All dancers will be rehearsing and doing full run-throughs of the show daily. Full details can be found in our Handbook.",
    },
    {
      eventName: "Dress Rehearsal",
      date: "01/17/26",
      title: "Swan Lake Dress Rehearsal",
      subtitle: "January 17",
      caption:
        "Dress rehearsal will take place at UTEP's Magoffin Auditorium. Full details can be found in the Swan Lake Handbook.",
    },
    {
      eventName: "Nylia Ballet Company's Swan Lake",
      date: "01/17/26",
      title: "Swan Lake",
      subtitle: "January 17 at 7 pm",
      caption: "UTEP's Magoffin Auditorium",
      buttonLink: perfSect2ButtonLink,
      buttonLabel: "RESERVE YOUR SEATS",
    },
  ];

  // const galleryImages = [{ imageSrc: "", title: "title", caption: "caption" }];
  // const galleryImages = [
  //   { imageSrc: gallery1 },
  //   { imageSrc: gallery2 },
  //   { imageSrc: gallery3 },
  //   { imageSrc: gallery4 },
  //   { imageSrc: gallery5 },
  //   { imageSrc: gallery6 },
  // ];

  return (
    <div id="swanLake2026Div">
      <PerformanceTemplate
        status={status}
        showName={showName}
        showDate={showDate}
        auditionDate={auditionDate}
        headerDescription={headerDescription}
        handbookLink={handbook}
        perfSect2ButtonLink={perfSect2ButtonLink}
        perfSect2Images={perfSect2Images}
        // importantLinks={importantLinks}
        // eventCalendar={eventCalendar}
        // galleryImages={galleryImages}
        performanceWeek={false}
        // perfSect2PerformanceWeekButtonLink={program}
      />
      <Footer />
    </div>
  );
}

export default SwanLake2026;
